import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";
import moment from "moment";

export const serviceRequestList = createAsyncThunk('serviceRequestList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `service_request`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'farm_id': data?.farmId,
                'request_type_id': data?.typeId,
                'requirement_date': data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const serviceRequestListSlice = createSlice({
    name: 'serviceRequestList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(serviceRequestList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(serviceRequestList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default serviceRequestListSlice.reducer; 